// extracted by mini-css-extract-plugin
export default {"imageWrapper":"dG-z","hovered":"eG-z","hoverImage":"fG-z","mainImage":"gG-z","imageNoBackground":"hG-z","fullSizeImage":"iG-z"};